module.exports = __webpack_public_path__ + "media/images/Plus-0ac7183cf3cafce0902bcb45eed221a1.svg";